export default __webpack_public_path__ + "static/media/3.c31ac033.svg";